import type { AppliedFrameResult } from './applied-frame';

export type AppliedFrameInput = string | AppliedFrameResult;
// Both raw/display runtimes and every host consume the same decoded plan. Only
// the most recent wire is retained; callers holding a plan need no string cache.
let lastWire: string | undefined, lastFrame: AppliedFrameResult | undefined;
let parses = 0;
export const appliedFramePlanMetrics = () => ({ parses });
export function parsedAppliedFrame(input: AppliedFrameInput): AppliedFrameResult {
    if (typeof input !== 'string') return input;
    if (lastWire === input && lastFrame) return lastFrame;
    const frame = JSON.parse(input) as AppliedFrameResult;
    parses++;
    lastWire = input; lastFrame = frame;
    return frame;
}
